document.addEventListener("DOMContentLoaded", function () {
  var desc = document.querySelector(".collection-hero__description");
  var btn = document.getElementById("hc-read-more-toggle");
  if (!desc || !btn) return;
  var originalHeight = desc.scrollHeight;
  if (desc.offsetHeight >= originalHeight) {
    btn.style.display = 'none';
  }
  btn.addEventListener("click", function () {
    desc.classList.toggle("expanded");
    btn.textContent = desc.classList.contains("expanded") ? "Read less" : "Read more";
  });
});
document.addEventListener("click", function (e) {
  const a = e.target.closest('.hc-popup-link a[data-src^="#"], .hc-popup-link a[href^="#"]');
  if (!a) return;
  const src = a.getAttribute("data-src") || a.getAttribute("href");
  if (!src || src === "#") return;
  const node = document.querySelector(src);
  if (!node) return;
  e.preventDefault();
  e.stopPropagation();

  function ensureFancybox() {
    if (window.Fancybox && typeof window.Fancybox.show === "function") {
      return Promise.resolve(window.Fancybox);
    }

    return new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[data-hc-fancybox="1"]');
      if (existing) {
        existing.addEventListener("load", function () { resolve(window.Fancybox); }, { once: true });
        existing.addEventListener("error", reject, { once: true });
        return;
      }

      var link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = "https://cdn.jsdelivr.net/npm/@fancyapps/ui/dist/fancybox.css";
      link.setAttribute("data-hc-fancybox", "1");
      document.head.appendChild(link);

      var script = document.createElement("script");
      script.src = "https://cdn.jsdelivr.net/npm/@fancyapps/ui@4.0/dist/fancybox.umd.js";
      script.defer = true;
      script.setAttribute("data-hc-fancybox", "1");
      script.onload = function () { resolve(window.Fancybox); };
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  ensureFancybox()
    .then(function (FancyboxLib) {
      if (!FancyboxLib || typeof FancyboxLib.show !== "function") return;
      FancyboxLib.show([{ src: src, type: "inline" }], {
        hideScrollbar: false,
        closeButton: true
      });
    })
    .catch(function () {});
}, true);

(function () {
  function isCollectionUrl(url) {
    try {
      var u = new URL(url, window.location.origin);
      return u.pathname.indexOf('/collections/') === 0;
    } catch (e) {
      return false;
    }
  }

  function saveLastCollectionFromReferrer() {
    var ref = document.referrer;
    if (ref && isCollectionUrl(ref)) {
      sessionStorage.setItem('hcLastCollection', ref);
    }
  }

  function saveLastCollectionFromCurrentPage() {
    if (window.location.pathname.indexOf('/collections/') === 0) {
      sessionStorage.setItem('hcLastCollection', window.location.href);
    }
  }

  function getLastCollection() {
    var v = sessionStorage.getItem('hcLastCollection');
    return v && isCollectionUrl(v) ? v : null;
  }

  function updateContinueLinks(scope) {
    var last = getLastCollection();
    if (!last) return;
    var root = scope && scope.querySelectorAll ? scope : document;
    var links = root.querySelectorAll('.hc-continue-link');
    for (var i = 0; i < links.length; i++) {
      links[i].setAttribute('href', last);
    }
  }

  function interceptAjaxifyCartFeedback() {
    if (!window.jQuery) return;

    var $ = window.jQuery;
    var attempts = 0;

    function tryPatch() {
      attempts++;
      if (attempts > 10) return;

      if (!window.Shopify || !window.Shopify.AjaxifyCart || typeof window.Shopify.AjaxifyCart.getConfig !== "function") {
        window.setTimeout(tryPatch, 200);
        return;
      }

      var cfg = window.Shopify.AjaxifyCart.getConfig && window.Shopify.AjaxifyCart.getConfig();
      if (!cfg) {
        return;
      }

      if (cfg.__hcPatchedShowFeedback) {
        return;
      }
      cfg.__hcPatchedShowFeedback = true;

      var originalBefore = $.fn.before;
      var originalAfter = $.fn.after;

      function patchInsert(originalFn) {
        return function () {
          var res = originalFn.apply(this, arguments);
          try {
            var htmlArg = arguments && arguments[0];
            if (typeof htmlArg === 'string' && htmlArg.indexOf('hc-continue-link') !== -1) {
              updateContinueLinks(document);
            }
          } catch (e) {}
          return res;
        };
      }

      $.fn.before = patchInsert(originalBefore);
      $.fn.after = patchInsert(originalAfter);
    }

    tryPatch();
  }

  function init() {
    saveLastCollectionFromCurrentPage();
    saveLastCollectionFromReferrer();

    if (window.location.pathname === '/cart' || window.location.pathname.indexOf('/cart') === 0) {
      updateContinueLinks(document);
    }

    updateContinueLinks(document);
    interceptAjaxifyCartFeedback();

    var mo = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (!m.addedNodes) continue;
        for (var j = 0; j < m.addedNodes.length; j++) {
          var node = m.addedNodes[j];
          if (!node || node.nodeType !== 1) continue;
          if (node.matches && (node.matches('.hc-continue-link') || node.querySelector('.hc-continue-link'))) {
            updateContinueLinks(node);
          }
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(function () {
      mo.disconnect();
    }, 30000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
